export default function Verticals() {
  const verticals = [
    {
      icon: 'ri-device-line',
      title: 'Wearables & Trackers',
      description: 'Smart collars, GPS trackers, and health monitoring devices',
      color: 'from-pink-400 to-rose-500',
      bgColor: 'bg-pink-50',
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'E-commerce & Retail',
      description: 'Online pet product stores and retail platforms',
      color: 'from-purple-400 to-indigo-500',
      bgColor: 'bg-purple-50',
    },
    {
      icon: 'ri-capsule-line',
      title: 'Health Supplements & Nutrition',
      description: 'Vitamins, supplements, and specialized nutrition products',
      color: 'from-teal-400 to-cyan-500',
      bgColor: 'bg-teal-50',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Food & Treats',
      description: 'Kibbles, fresh foods and functional snacks',
      color: 'from-orange-400 to-amber-500',
      bgColor: 'bg-orange-50',
    },
    {
      icon: 'ri-wifi-line',
      title: 'Pet Tech & IoT Devices',
      description: 'Smart feeders, cameras, home connected solutions',
      color: 'from-sky-400 to-blue-500',
      bgColor: 'bg-sky-50',
    },
    {
      icon: 'ri-brain-line',
      title: 'Wellness & Behavior Tech',
      description: 'Anxiety tools, training apps, behavioral monitoring and AI coaching',
      color: 'from-emerald-400 to-green-500',
      bgColor: 'bg-emerald-50',
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'Veterinary Tech & Services',
      description: 'Tech-enabled clinics, telemedicine, and vet platforms',
      color: 'from-red-400 to-rose-500',
      bgColor: 'bg-red-50',
    },
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#FF6B6B] to-[#6B5FFF] bg-clip-text text-transparent mb-6">
            Pet Verticals We Support
          </h2>
          <p className="text-lg text-[#4A5568] max-w-[700px] mx-auto">
            We work with founders across high-growth areas in the pet industry.
          </p>
        </div>

        {/* Verticals Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {verticals.map((vertical, index) => (
            <div
              key={index}
              className={`${vertical.bgColor} rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group`}
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${vertical.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                <i className={`${vertical.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-[#2D3748] mb-3 leading-tight">
                {vertical.title}
              </h3>
              <p className="text-sm text-[#4A5568] leading-relaxed">
                {vertical.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
